var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:!_vm.noPadding ? 'group' : null},[_c('div',[_vm._v(_vm._s(_vm.label))]),_c('div',{class:!_vm.noPadding ? 'element-wrapper' : 'element-wrapper-no-padding',style:(_vm.white ? 'background-color: white' : '')},[_c('div',{class:{
        flex: _vm.flex,
        flexStart: _vm.flexStart
      }},[_vm._t("default"),_vm._t("children")],2),_c('div',{style:(!_vm.small ? 'padding: 20px' : '')},[_vm._t("button")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }